
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexvYWcjstWLJwI535jJQlZopMZbLbomp2FGwbc3EQyPTAMeta } from "/var/www/html/pages/index/index.vue?macro=true";
import { default as _91id_93xMupy_lnetLe_4507nKRMNP8itlRlYDKoNsAShBRBdmaUMeta } from "/var/www/html/pages/seer/chat/[id].vue?macro=true";
import { default as indexmvAqwHE6aB1_455itnrYgONr5qrt8EM4i28_45iwf49TYLEMeta } from "/var/www/html/pages/seer/mall/index.vue?macro=true";
import { default as _91id_93R_45d24cJJcUX2k4Me4tbNCqyx2wIbkMdfLvjyh3uAL6gMeta } from "/var/www/html/pages/seer/order/[id].vue?macro=true";
import { default as index2NlYQcFP3RrWTlRAbfWWiPPPwk1bYNsU4dnRWlvO8_0Meta } from "/var/www/html/pages/seer/user/index.vue?macro=true";
import { default as indexjDlcZ8Im8dFXHGJxWPjoNqz17HX0n27faYFuGtxYYTgMeta } from "/var/www/html/pages/seer/login/index.vue?macro=true";
import { default as index9gHns2u_45bCnqvjmdZSHGA_Se2OoJdzVnJJlXMRhDYXoMeta } from "/var/www/html/pages/seer/tests/index.vue?macro=true";
import { default as _91id_93Rrgr9xLZFwVCqugf9C2sEL7iAsSwGhqma_45q_45LKV_45h08Meta } from "/var/www/html/pages/seer/creator/[id].vue?macro=true";
import { default as indexqcSAjcHC2Txi8XgqpwKGNOgSzlMCNrxLKUTp1Uny9A8Meta } from "/var/www/html/pages/seer/search/index.vue?macro=true";
import { default as indexF8yMKWiaiwh95fISKtwqhuhcPqxOA1V6RCen7HlHX9EMeta } from "/var/www/html/pages/seer/square/index.vue?macro=true";
import { default as indexFHeifvY_BVaeDBcjRZzJvgAvDberUnj5PAhdcmNkWZQMeta } from "/var/www/html/pages/seer/aboutus/index.vue?macro=true";
import { default as indexby_45mDdPfcZ_455ZTdjPZ8mRPQ7OZOCZ2Xb4RQE6RULdMoMeta } from "/var/www/html/pages/seer/bazi008/index.vue?macro=true";
import { default as indexRKO1EU8ZdxgKxrbnywJshYhdIRTyV6zxuxrrPynpnH0Meta } from "/var/www/html/pages/seer/bazi009/index.vue?macro=true";
import { default as indexQ9s0x9F8JmophSYNpe4Gza2nFF2xFPahnGrkaoDOafkMeta } from "/var/www/html/pages/seer/careers/index.vue?macro=true";
import { default as indexymISuun98pZSmDk8Bb8ass9oLdm_45uvZxSuUoptqMM9IMeta } from "/var/www/html/pages/seer/consult/index.vue?macro=true";
import { default as indexz4mgcauRbJWR6tq8mO8O4IgY86K4_45OmJ9mW5seANjM8Meta } from "/var/www/html/pages/seer/huangli/index.vue?macro=true";
import { default as chat1ABWP_hm0q8t9nyvXzsw6nfj9Ts_45F_450GhvEAzl_45RZSoMeta } from "/var/www/html/pages/seer/master-s/chat.vue?macro=true";
import { default as resultJTmKfsjxMdPO9meyja8szAllY2WZCEKti1OUSVfPVVAMeta } from "/var/www/html/pages/seer/consult/result.vue?macro=true";
import { default as index9w1aZP6ij4sbkud7BJPf9RgZf7SBflTE_45UMIiwNgqecMeta } from "/var/www/html/pages/seer/master-s/index.vue?macro=true";
import { default as indexJIM_45Vk283OkZ_ALThson747jIuycfX2fubYXJhYAgLUMeta } from "/var/www/html/pages/seer/onlinecs/index.vue?macro=true";
import { default as indexYsrCBrCoEKcqckANm0Km4UkXBqRxSkoHMtkVvlfuqZ0Meta } from "/var/www/html/pages/seer/bazi-file/index.vue?macro=true";
import { default as index3UwIUdd4UgmD2YjTSx_45NNbClQvIQ9aLFc9qgWyA6ipcMeta } from "/var/www/html/pages/seer/guide-chat/index.vue?macro=true";
import { default as indexoh8s5i6Hx_45Wjq4tOoLUPrPkB5wKZpcVwqpXKqceIfCcMeta } from "/var/www/html/pages/seer/manuscript/index.vue?macro=true";
import { default as recordsi5Y_NDlYPWfXJXvxMEMio0u_45D40bCqfKffbpA2X4UoAMeta } from "/var/www/html/pages/seer/master-s/records.vue?macro=true";
import { default as _91id_93AqMgvjNYerVeJaqjxyd0RViS4_yHJOLf_45U2Rvqs6uwYMeta } from "/var/www/html/pages/seer/goods-detail/[id].vue?macro=true";
import { default as indexifGDGNyMw0h6ByVSV_lb6VNlfEIGbNxFgLQt5SnECagMeta } from "/var/www/html/pages/seer/master-team/index.vue?macro=true";
import { default as indexacainTnYRW4Lwuk7S9QDNp2CxX48AUdAHU708K9_MLIMeta } from "/var/www/html/pages/seer/daily-energy/index.vue?macro=true";
import { default as indexxmnS3PJnZgZPKp7hh5IzpHfaMFNDyiWWcazQaSimEngMeta } from "/var/www/html/pages/seer/drainage/kol/index.vue?macro=true";
import { default as _91id_93z94W86XG_45c363sVEAL65BNS_FqYZb_aSBQOBE_45Qhn_45kMeta } from "/var/www/html/pages/seer/drainage/user/[id].vue?macro=true";
import { default as indexXBvi5Mwm07oFEuGUpBFvHRMiT_45S4pBtoQiOMWQo24S0Meta } from "/var/www/html/pages/seer/goods-result/index.vue?macro=true";
import { default as choose_45dayE4CN0P_WNWz5A3xPkpsCFx0OdYQR2lWgg_45y8GlCH_4508Meta } from "/var/www/html/pages/seer/huangli/choose-day.vue?macro=true";
import { default as _91id_93dslMuLNku1AS_45aNuHA9RnjwMDeKvkjlcWIDInHEaKjEMeta } from "/var/www/html/pages/seer/square-detail/[id].vue?macro=true";
import { default as index6USNWCr3I5PW5JMA9Ine7MZJvTPXKOn5u80_45LdcfQpgMeta } from "/var/www/html/pages/seer/renshengkxian/index.vue?macro=true";
import { default as index_7wZfWtu3gbgs1hByxO_ZBDhSzJ8gnK_45CV0jNIEUaYsMeta } from "/var/www/html/pages/seer/square/shorts/index.vue?macro=true";
import { default as _91id_93yKgSf8l9kg53PQUu5mqpLrsH45hk5v43LKHGf4PhZi0Meta } from "/var/www/html/pages/seer/teacher-detail/[id].vue?macro=true";
import { default as _91id_93HoOVCWDQqN6t_IsSQmQ9Hq8LXwg4SQxd8Uc_45r4gLAmoMeta } from "/var/www/html/pages/seer/drainage/common/[id].vue?macro=true";
import { default as indexcVzSBAKg7dk5UuHnU7sIQgSk3g4UHx39mdOAUtUBkagMeta } from "/var/www/html/pages/seer/master-fortune/index.vue?macro=true";
import { default as index3z2jlxZVNCaReRgraApmim_6tpQJBiAy5phuD_mF2QEMeta } from "/var/www/html/pages/seer/square/article/index.vue?macro=true";
import { default as indexazevgy4WgGagiTyhLy5Xiko2exdLIp2SJu13v1MX7BMMeta } from "/var/www/html/pages/seer/square/podcast/index.vue?macro=true";
import { default as _91type_93SyNTea50dliadvF7QYAS339EJF_457IGhV2N5GBoCugr4Meta } from "/var/www/html/pages/seer/quick-question/[type].vue?macro=true";
import { default as almanac_45detail6mlsbBDPYNCycBqI5NfcNMR2N5kYR75tahv4h_45_45BKPoMeta } from "/var/www/html/pages/seer/huangli/almanac-detail.vue?macro=true";
import { default as index4JxJRDT6Q_x50cTIxPBflc7b7YL7HxJ7sYpqG_45MMscUMeta } from "/var/www/html/pages/seer/mentor-join/join/index.vue?macro=true";
import { default as choose_45day_45listBxW2XjTz9QoaTJI1N8tLkcOUdeUUVzhqNGRKYk7pAE4Meta } from "/var/www/html/pages/seer/huangli/choose-day-list.vue?macro=true";
import { default as indexB8wVGpWcsax9SFvAtqxwvaJOqliXJfqb4A_7VKxUtfoMeta } from "/var/www/html/pages/seer/mentor-join/index/index.vue?macro=true";
import { default as previewRcz6ILWRvA9E9uQRoHytp3KGsayRtRqUuzCIe9nOhrAMeta } from "/var/www/html/pages/seer/corporate-center/preview.vue?macro=true";
import { default as _91id_93Dv7nSDevTE6mlKM_45q4MEol0b1rWv8AnO5rdzsfycx5gMeta } from "/var/www/html/pages/seer/drainage/short-play/[id].vue?macro=true";
import { default as index9YY1qYo7sMB8n_459K3yxPMWfpK0wk6La2zgoL_45Sg15X0Meta } from "/var/www/html/pages/seer/mentor-join/status/index.vue?macro=true";
import { default as allTeacheryALeVHSueZgfhZ1FwTt2ImoQTjzMX3_45mZlWADmNIINIMeta } from "/var/www/html/pages/seer/master-fortune/allTeacher.vue?macro=true";
import { default as indexNnY006XLgOcvzLRIa_30f_S4_wqpDWqhoPCve_450WE6UMeta } from "/var/www/html/pages/seer/service-institution/index.vue?macro=true";
import { default as indexLxDXKv_45Z1vuy_pJIH7QaII_PRSPV4P_hC2lp_NluNkcMeta } from "/var/www/html/pages/seer/corporate-center/edit/index.vue?macro=true";
import { default as index_U81xIT7zij842iwcDh9oqiFSx_TsUrOKJ2ctDUOIsQMeta } from "/var/www/html/pages/seer/corporate-center/info/index.vue?macro=true";
import { default as indexlO72g_AdbmtZCC8QJT6avtXUgXvkaU6LO_45rsGP0gfi0Meta } from "/var/www/html/pages/seer/corporate-center/join/index.vue?macro=true";
import { default as index_45xYukDae3dbvbeDxax_45zMnpqRoM0ZGwyY8EFnDkPjd4Meta } from "/var/www/html/pages/seer/corporate-center/index/index.vue?macro=true";
import { default as indexwciPGzzpXiU4joScGxw3ep661bhcnV_lM7yRDkygvGkMeta } from "/var/www/html/pages/seer/corporate-center/detail/index.vue?macro=true";
import { default as indexL45La7cay9qHkRxGUiD6YPAnUyENcXIm38Nm0RD6hLAMeta } from "/var/www/html/pages/seer/corporate-center/manage/index.vue?macro=true";
import { default as indexRIL46HXDpfDwHSkSYSmHTTETUBXVz78Fws_45y550zQcwMeta } from "/var/www/html/pages/seer/user/m/components/MyFollow/index.vue?macro=true";
import { default as index0SHxtfvjXWqELBHoA4AvAb_I9djug8KA21sNaPSDUnQMeta } from "/var/www/html/pages/seer/user/m/components/MyProfile/index.vue?macro=true";
import { default as _91serviceId_93W8DdX0kZHs7pJ32cm57wKZcF9bxfWf9W21tjqd1RsD0Meta } from "/var/www/html/pages/seer/teacher-service/[teacherId]/[serviceId].vue?macro=true";
import { default as indexiHFct6tRAEl4qMFfvjarO_Am00lY_45FkQ51cKNTHtC5MMeta } from "/var/www/html/pages/seer/user/m/components/UserCenterDrawer/index.vue?macro=true";
import { default as index8HsQ2lif0UfAZPOCkEW_45y48YoCWV9OudbzOwdzLeOd8Meta } from "/var/www/html/pages/seer/square/pc/components/square-page-tabs/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexvYWcjstWLJwI535jJQlZopMZbLbomp2FGwbc3EQyPTAMeta || {},
    component: () => import("/var/www/html/pages/index/index.vue")
  },
  {
    name: "seer-chat-id",
    path: "/seer/chat/:id()",
    meta: _91id_93xMupy_lnetLe_4507nKRMNP8itlRlYDKoNsAShBRBdmaUMeta || {},
    component: () => import("/var/www/html/pages/seer/chat/[id].vue")
  },
  {
    name: "seer-mall",
    path: "/seer/mall",
    meta: indexmvAqwHE6aB1_455itnrYgONr5qrt8EM4i28_45iwf49TYLEMeta || {},
    component: () => import("/var/www/html/pages/seer/mall/index.vue")
  },
  {
    name: "seer-order-id",
    path: "/seer/order/:id()",
    meta: _91id_93R_45d24cJJcUX2k4Me4tbNCqyx2wIbkMdfLvjyh3uAL6gMeta || {},
    component: () => import("/var/www/html/pages/seer/order/[id].vue")
  },
  {
    name: "seer-user",
    path: "/seer/user",
    meta: index2NlYQcFP3RrWTlRAbfWWiPPPwk1bYNsU4dnRWlvO8_0Meta || {},
    component: () => import("/var/www/html/pages/seer/user/index.vue")
  },
  {
    name: "seer-login",
    path: "/seer/login",
    meta: indexjDlcZ8Im8dFXHGJxWPjoNqz17HX0n27faYFuGtxYYTgMeta || {},
    component: () => import("/var/www/html/pages/seer/login/index.vue")
  },
  {
    name: "seer-tests",
    path: "/seer/tests",
    meta: index9gHns2u_45bCnqvjmdZSHGA_Se2OoJdzVnJJlXMRhDYXoMeta || {},
    component: () => import("/var/www/html/pages/seer/tests/index.vue")
  },
  {
    name: "seer-creator-id",
    path: "/seer/creator/:id()",
    meta: _91id_93Rrgr9xLZFwVCqugf9C2sEL7iAsSwGhqma_45q_45LKV_45h08Meta || {},
    component: () => import("/var/www/html/pages/seer/creator/[id].vue")
  },
  {
    name: "seer-search",
    path: "/seer/search",
    meta: indexqcSAjcHC2Txi8XgqpwKGNOgSzlMCNrxLKUTp1Uny9A8Meta || {},
    component: () => import("/var/www/html/pages/seer/search/index.vue")
  },
  {
    name: "seer-square",
    path: "/seer/square",
    meta: indexF8yMKWiaiwh95fISKtwqhuhcPqxOA1V6RCen7HlHX9EMeta || {},
    component: () => import("/var/www/html/pages/seer/square/index.vue")
  },
  {
    name: "seer-aboutus",
    path: "/seer/aboutus",
    meta: indexFHeifvY_BVaeDBcjRZzJvgAvDberUnj5PAhdcmNkWZQMeta || {},
    component: () => import("/var/www/html/pages/seer/aboutus/index.vue")
  },
  {
    name: "seer-bazi008",
    path: "/seer/bazi008",
    meta: indexby_45mDdPfcZ_455ZTdjPZ8mRPQ7OZOCZ2Xb4RQE6RULdMoMeta || {},
    component: () => import("/var/www/html/pages/seer/bazi008/index.vue")
  },
  {
    name: "seer-bazi009",
    path: "/seer/bazi009",
    meta: indexRKO1EU8ZdxgKxrbnywJshYhdIRTyV6zxuxrrPynpnH0Meta || {},
    component: () => import("/var/www/html/pages/seer/bazi009/index.vue")
  },
  {
    name: "seer-careers",
    path: "/seer/careers",
    meta: indexQ9s0x9F8JmophSYNpe4Gza2nFF2xFPahnGrkaoDOafkMeta || {},
    component: () => import("/var/www/html/pages/seer/careers/index.vue")
  },
  {
    name: "seer-consult",
    path: "/seer/consult",
    meta: indexymISuun98pZSmDk8Bb8ass9oLdm_45uvZxSuUoptqMM9IMeta || {},
    component: () => import("/var/www/html/pages/seer/consult/index.vue")
  },
  {
    name: "seer-huangli",
    path: "/seer/huangli",
    meta: indexz4mgcauRbJWR6tq8mO8O4IgY86K4_45OmJ9mW5seANjM8Meta || {},
    component: () => import("/var/www/html/pages/seer/huangli/index.vue")
  },
  {
    name: "seer-master-s-chat",
    path: "/seer/master-s/chat",
    meta: chat1ABWP_hm0q8t9nyvXzsw6nfj9Ts_45F_450GhvEAzl_45RZSoMeta || {},
    component: () => import("/var/www/html/pages/seer/master-s/chat.vue")
  },
  {
    name: "seer-consult-result",
    path: "/seer/consult/result",
    meta: resultJTmKfsjxMdPO9meyja8szAllY2WZCEKti1OUSVfPVVAMeta || {},
    component: () => import("/var/www/html/pages/seer/consult/result.vue")
  },
  {
    name: "seer-master-s",
    path: "/seer/master-s",
    meta: index9w1aZP6ij4sbkud7BJPf9RgZf7SBflTE_45UMIiwNgqecMeta || {},
    component: () => import("/var/www/html/pages/seer/master-s/index.vue")
  },
  {
    name: "seer-onlinecs",
    path: "/seer/onlinecs",
    meta: indexJIM_45Vk283OkZ_ALThson747jIuycfX2fubYXJhYAgLUMeta || {},
    component: () => import("/var/www/html/pages/seer/onlinecs/index.vue")
  },
  {
    name: "seer-bazi-file",
    path: "/seer/bazi-file",
    meta: indexYsrCBrCoEKcqckANm0Km4UkXBqRxSkoHMtkVvlfuqZ0Meta || {},
    component: () => import("/var/www/html/pages/seer/bazi-file/index.vue")
  },
  {
    name: "seer-guide-chat",
    path: "/seer/guide-chat",
    meta: index3UwIUdd4UgmD2YjTSx_45NNbClQvIQ9aLFc9qgWyA6ipcMeta || {},
    component: () => import("/var/www/html/pages/seer/guide-chat/index.vue")
  },
  {
    name: "seer-manuscript",
    path: "/seer/manuscript",
    meta: indexoh8s5i6Hx_45Wjq4tOoLUPrPkB5wKZpcVwqpXKqceIfCcMeta || {},
    component: () => import("/var/www/html/pages/seer/manuscript/index.vue")
  },
  {
    name: "seer-master-s-records",
    path: "/seer/master-s/records",
    meta: recordsi5Y_NDlYPWfXJXvxMEMio0u_45D40bCqfKffbpA2X4UoAMeta || {},
    component: () => import("/var/www/html/pages/seer/master-s/records.vue")
  },
  {
    name: "seer-goods-detail-id",
    path: "/seer/goods-detail/:id()",
    meta: _91id_93AqMgvjNYerVeJaqjxyd0RViS4_yHJOLf_45U2Rvqs6uwYMeta || {},
    component: () => import("/var/www/html/pages/seer/goods-detail/[id].vue")
  },
  {
    name: "seer-master-team",
    path: "/seer/master-team",
    meta: indexifGDGNyMw0h6ByVSV_lb6VNlfEIGbNxFgLQt5SnECagMeta || {},
    component: () => import("/var/www/html/pages/seer/master-team/index.vue")
  },
  {
    name: "seer-daily-energy",
    path: "/seer/daily-energy",
    meta: indexacainTnYRW4Lwuk7S9QDNp2CxX48AUdAHU708K9_MLIMeta || {},
    component: () => import("/var/www/html/pages/seer/daily-energy/index.vue")
  },
  {
    name: "seer-drainage-kol",
    path: "/seer/drainage/kol",
    meta: indexxmnS3PJnZgZPKp7hh5IzpHfaMFNDyiWWcazQaSimEngMeta || {},
    component: () => import("/var/www/html/pages/seer/drainage/kol/index.vue")
  },
  {
    name: "seer-drainage-user-id",
    path: "/seer/drainage/user/:id()",
    meta: _91id_93z94W86XG_45c363sVEAL65BNS_FqYZb_aSBQOBE_45Qhn_45kMeta || {},
    component: () => import("/var/www/html/pages/seer/drainage/user/[id].vue")
  },
  {
    name: "seer-goods-result",
    path: "/seer/goods-result",
    meta: indexXBvi5Mwm07oFEuGUpBFvHRMiT_45S4pBtoQiOMWQo24S0Meta || {},
    component: () => import("/var/www/html/pages/seer/goods-result/index.vue")
  },
  {
    name: "seer-huangli-choose-day",
    path: "/seer/huangli/choose-day",
    meta: choose_45dayE4CN0P_WNWz5A3xPkpsCFx0OdYQR2lWgg_45y8GlCH_4508Meta || {},
    component: () => import("/var/www/html/pages/seer/huangli/choose-day.vue")
  },
  {
    name: "seer-square-detail-id",
    path: "/seer/square-detail/:id()",
    meta: _91id_93dslMuLNku1AS_45aNuHA9RnjwMDeKvkjlcWIDInHEaKjEMeta || {},
    component: () => import("/var/www/html/pages/seer/square-detail/[id].vue")
  },
  {
    name: "seer-renshengkxian",
    path: "/seer/renshengkxian",
    meta: index6USNWCr3I5PW5JMA9Ine7MZJvTPXKOn5u80_45LdcfQpgMeta || {},
    component: () => import("/var/www/html/pages/seer/renshengkxian/index.vue")
  },
  {
    name: "seer-square-shorts",
    path: "/seer/square/shorts",
    meta: index_7wZfWtu3gbgs1hByxO_ZBDhSzJ8gnK_45CV0jNIEUaYsMeta || {},
    component: () => import("/var/www/html/pages/seer/square/shorts/index.vue")
  },
  {
    name: "seer-teacher-detail-id",
    path: "/seer/teacher-detail/:id()",
    meta: _91id_93yKgSf8l9kg53PQUu5mqpLrsH45hk5v43LKHGf4PhZi0Meta || {},
    component: () => import("/var/www/html/pages/seer/teacher-detail/[id].vue")
  },
  {
    name: "seer-drainage-common-id",
    path: "/seer/drainage/common/:id()",
    meta: _91id_93HoOVCWDQqN6t_IsSQmQ9Hq8LXwg4SQxd8Uc_45r4gLAmoMeta || {},
    component: () => import("/var/www/html/pages/seer/drainage/common/[id].vue")
  },
  {
    name: "seer-master-fortune",
    path: "/seer/master-fortune",
    meta: indexcVzSBAKg7dk5UuHnU7sIQgSk3g4UHx39mdOAUtUBkagMeta || {},
    component: () => import("/var/www/html/pages/seer/master-fortune/index.vue")
  },
  {
    name: "seer-square-article",
    path: "/seer/square/article",
    meta: index3z2jlxZVNCaReRgraApmim_6tpQJBiAy5phuD_mF2QEMeta || {},
    component: () => import("/var/www/html/pages/seer/square/article/index.vue")
  },
  {
    name: "seer-square-podcast",
    path: "/seer/square/podcast",
    meta: indexazevgy4WgGagiTyhLy5Xiko2exdLIp2SJu13v1MX7BMMeta || {},
    component: () => import("/var/www/html/pages/seer/square/podcast/index.vue")
  },
  {
    name: "seer-quick-question-type",
    path: "/seer/quick-question/:type()",
    meta: _91type_93SyNTea50dliadvF7QYAS339EJF_457IGhV2N5GBoCugr4Meta || {},
    component: () => import("/var/www/html/pages/seer/quick-question/[type].vue")
  },
  {
    name: "seer-huangli-almanac-detail",
    path: "/seer/huangli/almanac-detail",
    meta: almanac_45detail6mlsbBDPYNCycBqI5NfcNMR2N5kYR75tahv4h_45_45BKPoMeta || {},
    component: () => import("/var/www/html/pages/seer/huangli/almanac-detail.vue")
  },
  {
    name: "seer-mentor-join-join",
    path: "/seer/mentor-join/join",
    meta: index4JxJRDT6Q_x50cTIxPBflc7b7YL7HxJ7sYpqG_45MMscUMeta || {},
    component: () => import("/var/www/html/pages/seer/mentor-join/join/index.vue")
  },
  {
    name: "seer-huangli-choose-day-list",
    path: "/seer/huangli/choose-day-list",
    meta: choose_45day_45listBxW2XjTz9QoaTJI1N8tLkcOUdeUUVzhqNGRKYk7pAE4Meta || {},
    component: () => import("/var/www/html/pages/seer/huangli/choose-day-list.vue")
  },
  {
    name: "seer-mentor-join-index",
    path: "/seer/mentor-join",
    meta: indexB8wVGpWcsax9SFvAtqxwvaJOqliXJfqb4A_7VKxUtfoMeta || {},
    component: () => import("/var/www/html/pages/seer/mentor-join/index/index.vue")
  },
  {
    name: "seer-corporate-center-preview",
    path: "/seer/corporate-center/preview",
    meta: previewRcz6ILWRvA9E9uQRoHytp3KGsayRtRqUuzCIe9nOhrAMeta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/preview.vue")
  },
  {
    name: "seer-drainage-short-play-id",
    path: "/seer/drainage/short-play/:id()",
    meta: _91id_93Dv7nSDevTE6mlKM_45q4MEol0b1rWv8AnO5rdzsfycx5gMeta || {},
    component: () => import("/var/www/html/pages/seer/drainage/short-play/[id].vue")
  },
  {
    name: "seer-mentor-join-status",
    path: "/seer/mentor-join/status",
    meta: index9YY1qYo7sMB8n_459K3yxPMWfpK0wk6La2zgoL_45Sg15X0Meta || {},
    component: () => import("/var/www/html/pages/seer/mentor-join/status/index.vue")
  },
  {
    name: "seer-master-fortune-allTeacher",
    path: "/seer/master-fortune/allTeacher",
    meta: allTeacheryALeVHSueZgfhZ1FwTt2ImoQTjzMX3_45mZlWADmNIINIMeta || {},
    component: () => import("/var/www/html/pages/seer/master-fortune/allTeacher.vue")
  },
  {
    name: "seer-service-institution",
    path: "/seer/service-institution",
    meta: indexNnY006XLgOcvzLRIa_30f_S4_wqpDWqhoPCve_450WE6UMeta || {},
    component: () => import("/var/www/html/pages/seer/service-institution/index.vue")
  },
  {
    name: "seer-corporate-center-edit",
    path: "/seer/corporate-center/edit",
    meta: indexLxDXKv_45Z1vuy_pJIH7QaII_PRSPV4P_hC2lp_NluNkcMeta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/edit/index.vue")
  },
  {
    name: "seer-corporate-center-info",
    path: "/seer/corporate-center/info",
    meta: index_U81xIT7zij842iwcDh9oqiFSx_TsUrOKJ2ctDUOIsQMeta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/info/index.vue")
  },
  {
    name: "seer-corporate-center-join",
    path: "/seer/corporate-center/join",
    meta: indexlO72g_AdbmtZCC8QJT6avtXUgXvkaU6LO_45rsGP0gfi0Meta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/join/index.vue")
  },
  {
    name: "seer-corporate-center-index",
    path: "/seer/corporate-center",
    meta: index_45xYukDae3dbvbeDxax_45zMnpqRoM0ZGwyY8EFnDkPjd4Meta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/index/index.vue")
  },
  {
    name: "seer-corporate-center-detail",
    path: "/seer/corporate-center/detail",
    meta: indexwciPGzzpXiU4joScGxw3ep661bhcnV_lM7yRDkygvGkMeta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/detail/index.vue")
  },
  {
    name: "seer-corporate-center-manage",
    path: "/seer/corporate-center/manage",
    meta: indexL45La7cay9qHkRxGUiD6YPAnUyENcXIm38Nm0RD6hLAMeta || {},
    component: () => import("/var/www/html/pages/seer/corporate-center/manage/index.vue")
  },
  {
    name: "seer-user-m-components-MyFollow",
    path: "/seer/user/m/components/MyFollow",
    component: () => import("/var/www/html/pages/seer/user/m/components/MyFollow/index.vue")
  },
  {
    name: "seer-user-m-components-MyProfile",
    path: "/seer/user/m/components/MyProfile",
    component: () => import("/var/www/html/pages/seer/user/m/components/MyProfile/index.vue")
  },
  {
    name: "seer-teacher-service-teacherId-serviceId",
    path: "/seer/teacher-service/:teacherId()/:serviceId()",
    meta: _91serviceId_93W8DdX0kZHs7pJ32cm57wKZcF9bxfWf9W21tjqd1RsD0Meta || {},
    component: () => import("/var/www/html/pages/seer/teacher-service/[teacherId]/[serviceId].vue")
  },
  {
    name: "seer-user-m-components-UserCenterDrawer",
    path: "/seer/user/m/components/UserCenterDrawer",
    component: () => import("/var/www/html/pages/seer/user/m/components/UserCenterDrawer/index.vue")
  },
  {
    name: "seer-square-pc-components-square-page-tabs",
    path: "/seer/square/pc/components/square-page-tabs",
    component: () => import("/var/www/html/pages/seer/square/pc/components/square-page-tabs/index.vue")
  }
]